import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useToast } from '../../../../../../helpers/commonFunction'
import { deleteAsset } from '../../../../../../stateManager/store/formCreation_v2/actions'
import { Http } from '../../../../../../helpers/axois'
import { AppState } from '../../../../../../stateManager/store'
import { Modal } from "../../../../../../helpers/commonUi";
import { Component } from './Component'

const DELETE_CONFIRM_MSG = "Are you sure you want to delete the asset?"

export const List = (props:any) => {
  const { searchData } = props;
  const dispatch = useDispatch()
  const assets = useSelector((state: AppState) => state.formJson.assets)
  const [modalVisible, setModalVisible] = useState(false)
  const orgId = useSelector((state: any) => state.org.selectedOrg.id)
  const [selectedAsset, setSelectedAsset] = useState({
    id: "",
    assetId: "",
  })
  const [assetData, setAssetData] = useState<any>(null);
  const { ErrorToast, SuccessToast } = useToast()

  const handleDeleteAsset = async () => {
    const { id, assetId } = selectedAsset
    if(id && selectedAsset) {
      try {
        await Http.delete(`/orgs/${orgId}/assets/${id}`).toPromise()
        dispatch(deleteAsset({ id: assetId }))
        SuccessToast("Successfully deleted")
      } catch(err) {
        ErrorToast("Failed to delete asset")
      } finally {
        setModalVisible(false)
        setSelectedAsset({ id: "", assetId: "" })
      }
    }
  }

  useEffect(() => {
    let filterAssets: any = [];
    if (searchData) {
      filterAssets = Object.values(assets).filter((items: any) => {
        if (items?.label && items?.label.toLowerCase().indexOf(searchData.toLowerCase()) > -1) {
          return items;
        }
      })
      setAssetData(filterAssets)
    } else {
      setAssetData(assets)
    }
  }, [ searchData, assets ])

  return (
    <div className="mt-12 p-3">
      {assetData && Object.values(assetData).map((asset: any) => {
        const {assetId}: any = asset
        return (
          <Component
            key={assetId}
            asset={asset}
            assetId={assetId}
            openModal={() => setModalVisible(true)}
            setAsset={(data: any) => setSelectedAsset(data)}
          />
        );
      })}
      <Modal
        id="assetDelete"
        unmountOnCancel
        visible={modalVisible}
        title="DELETE ASSET"
        onCancel={() => setModalVisible(false)}
        footer={{
          enable: true,
          okText: "DELETE",
          cancelText: "CANCEL",
          onOk: handleDeleteAsset,
        }}
      >
        <p
          style={{
            fontSize: 16,
            color: "#10002E",
            margin: "16px 20px",
            fontWeight: 600
          }}
        >
          {DELETE_CONFIRM_MSG}
        </p>
      </Modal>
    </div>
  )
}
